import { axiosInstance, axiosNewApiV3 } from './axios';

// Mirrors the routes the Cloudflare Worker diverts from the legacy host to the APIM/BFF
// (homer.partnership.service, cloudflare/legacy-to-bff-worker.js, origin/develop @ 09c391a).
// Calling the APIM directly bypasses the Worker, so there is no fallback to the legacy: a URL
// shape the Worker would NOT divert (non-numeric id, empty segment...) must stay on the legacy
// client, otherwise the APIM answers 404/400 for it. Only routes this front actually calls are
// listed; everything else keeps using axiosInstance. Paths are relative to /api/v3 and matched
// case-insensitively, like the Worker does. Removing a line sends that route back to the legacy.
export const APIM_ROUTES = [
  // MIGRATED: users/{id} (GET and DELETE; only GET is called here).
  { method: 'GET', pattern: /^\/users\/\d+$/i },
  // HM-135: propertytypes, no parameters.
  { method: 'GET', pattern: /^\/propertytypes$/i },
  // HM-132: active posts of a broker's personal site.
  { method: 'GET', pattern: /^\/personal-site\/posts\/active\/users\/\d+\/paginate\/\d+\/\d+$/i },
  // HM-136: personal site lookup by SiteName (exactly one segment).
  { method: 'GET', pattern: /^\/personal-site\/[^/]+$/i },
  // locations/geocode/places/{GooglePlaceId}, trailing slash tolerated.
  { method: 'GET', pattern: /^\/locations\/geocode\/places\/[^/]+\/?$/i },
  // locations/{lat}/{lng}/{location}/simplified.
  { method: 'GET', pattern: /^\/locations\/[^/]+\/[^/]+\/[^/]+\/simplified$/i },
  // Isolated block (HM-098): POST personal-site/map/search, exact path, no trailing slash.
  { method: 'POST', pattern: /^\/personal-site\/map\/search$/i },
];

export const isApimRoute = (method, url) => {
  const path = String(url).split(/[?#]/)[0];
  const upperMethod = String(method).toUpperCase();
  return APIM_ROUTES.some((route) => route.method === upperMethod && route.pattern.test(path));
};

export const pickClient = (method, url) => (
  isApimRoute(method, url) ? axiosNewApiV3 : axiosInstance
);
